import { darkTheme } from '@rainbow-me/rainbowkit';

export const purpleTheme = darkTheme({
  accentColor: '#9C75FF',
  accentColorForeground: 'white',
  borderRadius: 'medium',
});

// Match app's deep purple palette
purpleTheme.colors.modalBackground = '#1E0E38';
purpleTheme.colors.modalBorder = 'rgba(156, 117, 255, 0.15)';
purpleTheme.colors.profileForeground = '#170B29';
purpleTheme.colors.generalBorder = 'rgba(156, 117, 255, 0.2)';
purpleTheme.colors.menuItemBackground = 'rgba(156, 117, 255, 0.08)';
purpleTheme.fonts.body = '"Atyp BL Text", "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif';
